<div>
  <input
    #dayToExecute="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="ag-text-field-input daytoexecute"
    type="text"
    [(ngModel)]="currentValue"
    (click)="openMenu()"
    [ngClass]="currentValue ? 'input-background-active' : ''" />
    @if (!currentValue) {
      <span class="sdps-dropdown__icon sch-chevron-small-down"></span>
    }
    @if (currentValue) {
      <span class="sdps-text-secondary delete-icon-padding" (click)="clearDayToExecute($event)"
        ><img class="deleteIcon" [src]="deleteIcon"
      /></span>
    }
    <ng-template
      cdkConnectedOverlay
      (overlayOutsideClick)="toggleDayToExecute(false)"
      [cdkConnectedOverlayOrigin]="dayToExecute"
      [cdkConnectedOverlayOpen]="isOpen">
      <div class="container">
        <div class="day-to-execute-grp ag-theme-material">
          <div class="ag-simple-filter-body-wrapper">
            <label class="weekday-label"> Weekday </label>
            <div class="ag-filter-select ag-labeled ag-label-align-left ag-select">
              <div class="ag-wrapper ag-picker-field-wrapper day-to-execute-field-wrapper">
                <mat-select
                  [(value)]="selectedValue"
                  placeholder="Select"
                  (selectionChange)="onDayToExcecuteSelected($event)"
                  disableOptionCentering>
                  @for (day of daytoExecuteWeekDays; track day) {
                    <mat-option [value]="day">{{day}}</mat-option>
                  }
                </mat-select>
              </div>
            </div>
            <div style="text-align: center">
              <label> OR </label>
            </div>
            <div class="ag-filter-from ag-filter-filter ag-labeled ag-label-align-left ag-number-field ag-input-field">
              <div class="ag-wrapper ag-input-wrapper ag-number-field-input-wrapper">
                <input
                  [(ngModel)]="dayFrom"
                  (change)="dayFrequencyInputChanged()"
                  id="dayFrom"
                  class="ag-input-field-input ag-number-field-input"
                  type="number"
                  placeholder="Day From" />
                </div>
              </div>
              <div class="ag-filter-from ag-filter-filter ag-labeled ag-label-align-left ag-number-field ag-input-field">
                <div class="ag-wrapper ag-input-wrapper ag-number-field-input-wrapper">
                  <input
                    [(ngModel)]="dayTo"
                    (change)="dayFrequencyInputChanged()"
                    class="ag-input-field-input ag-number-field-input"
                    id="dayTo"
                    type="number"
                    placeholder="Day To" />
                  </div>
                </div>
              </div>
            </div>
            <div class="filter-actions">
              <button type="button" class="btn btn-success" (click)="applyDayToExecute()">Apply</button>
              <a href="#" (click)="clearDayToExecute($event)"> Clear </a>
            </div>
          </div>
        </ng-template>
      </div>
